module.exports = __webpack_public_path__ + "static/amazonLogo-c6fce693dcb318977d0a519315e405a4.png";